import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Arrow } from '../../../components/Arrow/Arrow';
import { Button } from '../../../components/Button';
import { Heading } from '../../../components/Heading';
import { Icon } from '../../../components/Icon';
import { useAppRoutes } from '../../../hooks/useAppRoutes';
import { Recommendations } from '../../Recommendations';

const recommendationsId = 'recommendations';

export const StepSuccess: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [areRecommendationsVisible, setAreRecommendationsVisible] =
    useState(false);

  const { briefingSelectionRoute, projectOverviewRoute } = useAppRoutes();

  const onGoToInspiration = () =>
    document.getElementById(recommendationsId)?.scrollIntoView({
      behavior: 'smooth',
    });

  const onStartNewFormulation = () => {
    navigate(briefingSelectionRoute);
  };

  const onSeeProjectOverview = () => {
    navigate(projectOverviewRoute);
  };

  return (
    <div className="mx-3 lg:ml-5">
      <div className="max-w-full m-auto">
        <div className="flex flex-grow flex-wrap justify-center xl:max-w-6xl">
          <div className="w-full sm:w-10/12 lg:w-8/12 font-regular">
            <div className="whitespace-pre-wrap mt-12 sm:mt-10">
              <Heading
                level="h1"
                margin={1}
                align="center"
                text={t('components:success:heading')}
              />
              <p className="text-center pt-6">{t('components:success:emailInfo')}</p>
            </div>
            <div className="flex flex-col items-center justify-center max-w-screen-md mt-12 lg:mx-auto">
              <Heading
                level="h3"
                align="center"
                weight="medium"
                text={t('components:success:whatsNext:heading')}
              />
              <div className="flex flex-col md:flex-row">
                <div className="flex flex-row items-center flex-1">
                  <span className="flex-none w-32">
                    <Icon name="OrderHistory" />
                  </span>
                  <p>{t('components:success:whatsNext:review')}</p>
                </div>
                <Arrow
                  className="hidden place-self-center md:flex"
                  direction="right"
                  size={3}
                />
                <Arrow
                  className="flex-1 place-self-center md:hidden ml-32"
                  direction="bottom"
                  size={10}
                  aspectRatio={0.12}
                />
                <div className="flex flex-row items-center flex-1">
                  <span className="flex-none w-32">
                    <Icon name="AccountSettings" />
                  </span>
                  <p>{t('components:success:whatsNext:contact')}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full lg:w-9/12">
            <div className="flex flex-col items-center justify-center mt-5 -mx-3 md:flex-row">
              {areRecommendationsVisible && (
                <div className="mx-3 mb-4">
                  <Button
                    onClick={onGoToInspiration}
                    label={t('linksOrButtons:goToInspiration')}
                    variant="secondary"
                  />
                </div>
              )}
              <div className="mx-3 mb-4">
                <Button
                  onClick={onStartNewFormulation}
                  label={t('linksOrButtons:startNewFormulation')}
                  variant="secondary"
                />
              </div>
              <div className="mx-3 mb-4">
                <Button
                  onClick={onSeeProjectOverview}
                  label={t('linksOrButtons:seeProjectOverview')}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr className="mx-3 mt-6 mb-9 border-gray-300" />
      <Recommendations
        id={recommendationsId}
        onVisibilityChange={setAreRecommendationsVisible}
      />
    </div>
  );
};
